import { ThhHundAction, ThhHundActions } from '../thhHundActions';
import { AntragsummerGenerated } from '../actiontypes/antragsummerGenerated';

export const antragsnummerReducer = function (
  sectionState: string = null,
  action: ThhHundAction<AntragsummerGenerated>,
): string {
  switch (action.type) {
    case ThhHundActions.ANTRAGSNUMMER_GENERATED: {
      return action.payload.antragsnummer;
    }
    default:
      return sectionState;
  }
};
